import branding from '@/environment/branding.config';
import { AppConfigSchema } from '@/models';

import siteUIVersionData from './version_config_provided_by_build_script.json';

const ONE_SECOND = 1000;
const ONE_MINUTE = ONE_SECOND * 60;

const getAppConfig = (): AppConfigSchema => {
  return {
    apiHost: vwConfig?.NODE_ENV === 'local' ? 'http://localhost:8088' : '/api',
    auth0Config: {
      audience: vwConfig?.VW_AUTH_AUDIENCE,
      clientId: vwConfig?.VW_AUTH_CLIENT_ID,
      domain: vwConfig?.VW_AUTH_DOMAIN,
      redirectUri: window.location.origin
    },
    branding,
    environment: vwConfig?.NODE_ENV || 'prod',
    landingPage: '/plans',
    loginPage: '/',
    promptBeforeIdle: (vwConfig?.VW_IDLE_PROMPT || 5) * ONE_MINUTE,
    timeout: (vwConfig?.VW_TIMEOUT_PROMPT || 40) * ONE_MINUTE,
    uiVersionDetails: siteUIVersionData.version
  };
};

export default getAppConfig();
